module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBold.168ee76.woff2";